import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, errMsg } from "../../lib/api";

export default function AdminReset() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(null);
    if (pw !== pw2) { setError("Passwords don't match."); return; }
    setBusy(true);
    try {
      await api.post("/admin/reset-password", { token, new_password: pw });
      setDone(true);
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  return (
    <div className="login-body adm">
      <div className="login-card">
        <div className="login-brand"><span className="lb-mark">TL</span> AUCTIONS <em>· Control Room</em></div>
        <h1>Choose a new password</h1>
        {error && <div className="msg err" data-testid="reset-error">{error}</div>}
        {done ? (
          <div data-testid="reset-success">
            <p className="muted" style={{ lineHeight: 1.6 }}>Your password has been updated. You can sign in with it now.</p>
            <button className="btn-primary" onClick={() => navigate("/admin")} data-testid="reset-goto-login">Sign in</button>
          </div>
        ) : !token ? (
          <p className="muted" data-testid="reset-no-token">This reset link is missing its token. Please use the link from your email, or request a new one from the sign-in page.</p>
        ) : (
          <form onSubmit={submit} data-testid="reset-form">
            <label>New password
              <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" required minLength={8} autoFocus data-testid="reset-password" />
            </label>
            <label>Repeat new password
              <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" required minLength={8} data-testid="reset-confirm" />
            </label>
            <button type="submit" className="btn-primary" disabled={busy} data-testid="reset-submit">{busy ? "…" : "Set new password"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
